import { toast } from 'sonner';

export function copyToClipboard({ text, successMessage }: { text: string; successMessage?: string }) {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(successMessage || 'Copied to clipboard');
    })
    .catch(() => {
      toast.error('Failed to copy to clipboard');
    });
}
